import { GlobalFilter } from "projects/shared/src/models/global/GlobalFilter";


export class GeneralAttachmentsDataFilter extends GlobalFilter {
  ticketId!: number;
}
